import { IndexedPublicationsSection } from 'about/ui/indexedPublications/IndexedPublicationsSection'

export const indexedPublicationsAToC: readonly IndexedPublicationsSection[] = [
  {
    letter: 'A',
    references: [
      '@bib{aaboe1968atypical};',
      '@bib{abraham2004business};',
      '@bib{RN2544};',
      '@bib{RN3108axd};',
      '@bib{RN108};',
      '@bib{RN3108};',
      '@bib{ahmad2007archives};',
      '@bib{AitSaidGhanem2020archives};',
      '@bib{StPM_13};',
      '@bib{ali1970sumerian};',
      '@bib{Ali_Sumer_61};',
      '@bib{AlMagasees2023FSMaul};',
      '@bib{Al-Rawi1991More};',
      '@bib{CT0058};',
      '@bib{Altavilla2005Neo-Sumerian};',
      '@bib{alzeebari1964altbabylonische};',
      '@bib{TIM_1};',
      '@bib{RN760};',
      '@bib{RN1688};',
      '@bib{Arnaud1976UET7};',
      '@bib{Asyag2023Corpus};',
      '@bib{Attia2003JMC1};',
      '@bib{Attia2005JMC6}',
    ],
  },
  {
    letter: 'B',
    references: [
      '@bib{Bacskay2021JMC38};',
      '@bib{baker2004archive};',
      '@bib{Balensiefen2023FSMaul};',
      '@bib{baragli2022sonnengruesse};',
      '@bib{fromebllab0034};',
      '@bib{fromebllab0023};',
      '@bib{Baragli2023Utu};',
      '@bib{fromebllab0035};',
      '@bib{Bartash2015Nisaba25};',
      '@bib{RN2813};',
      '@bib{RN3501};',
      '@bib{barton1900some}; ',
      '@bib{PBS_9_1};',
      '@bib{RN1744};',
      '@bib{YOS_19};',
      '@bib{RN2374};',
      '@bib{RN72aa};',
      '@bib{Beckman1987Three};',
      '@bib{Beckman1988Catalogue};',
      '@bib{Beckman1988Join-piece};',
      '@bib{BelmonteMarín1997Old};',
      '@bib{beltz2025everyday};',
      '@bib{fromebllab0047};',
      '@bib{Beranger2020troupeaux};',
      '@bib{Beranger2020reprNABU2020-52};',
      '@bib{Beranger2020reprNABU2020-53};',
      '@bib{Beranger2020reprNABU2020-54};',
      '@bib{bernhardtSumerischeLiterarischeTexte1961}; ',
      '@bib{bernhardtSumerischeLiterarischeTexte1967}; ',
      '@bib{bernhardtSozialokonomischeTexteUnd1976};',
      '@bib{RN1800};',
      '@bib{RN429xdd};',
      '@bib{Biggs_Al-Hiba_1976};',
      '@bib{biggs1988early};',
      '@bib{biggs2006appendix};',
      '@bib{NABU1987-34};',
      '@bib{Nisaba_19};',
      '@bib{RN61};',
      '@bib{RN62}; ',
      '@bib{RN1459};',
      '@bib{Böck2011Die};',
      '@bib{RN64ax};',
      '@bib{Boeck2023FSMaul};',
      '@bib{RN59aa};',
      '@bib{deBoer2016Yahrurum};',
      '@bib{deBoer2016YahrurumShaplum};',
      '@bib{deBoer2017Two};',
      '@bib{Boehl1932Inschriften};',
      '@bib{UBHD-65281075};',
      '@bib{RN3177};',
      '@bib{RN850};',
      '@bib{Borger1954Omentext};',
      '@bib{Borger1988Koenig};',
      '@bib{RN54}; ',
      '@bib{RN56};',
      '@bib{RN883};',
      '@bib{RN773};',
      '@bib{Brinkman2017Babylonia};',
      '@bib{RN1530};',
      '@bib{RN1599};',
      '@bib{UET_2};',
      '@bib{RN32};',
      '@bib{Butz1980Frauenerbrecht};',
      '@bib{Butz1980Niessbrauch}',
    ],
  },
  {
    letter: 'C',
    references: [
      '@bib{AbB_8};',
      '@bib{Cagni1983Miscellanea};',
      '@bib{CT0011};',
      '@bib{CT0012};',
      '@bib{RN2604mm};',
      '@bib{CT0016}; ',
      '@bib{RN2604z};',
      '@bib{RN584};',
      '@bib{CT0018};',
      '@bib{CT0019};',
      '@bib{CT0020};',
      '@bib{CT0022}; ',
      '@bib{CT0023};',
      '@bib{campbellthompson1927catalogue};',
      '@bib{RN2980};',
      '@bib{Caplice1973Further};',
      '@bib{LS230};',
      '@bib{RN2406};',
      '@bib{LS134};',
      '@bib{RN1294};',
      '@bib{RN21};',
      '@bib{Cecilia2019Late};',
      '@bib{Charpin2020decouvertes};',
      '@bib{Charpin2020documents};',
      '@bib{Charpin2020archives};',
      '@bib{Charpin2020tablettes};',
      '@bib{Charpin2020temple};',
      '@bib{Charpin2020Enanedu};',
      '@bib{Charpin2020ventes};',
      '@bib{Charpin2020reprNABU2017-42};',
      '@bib{Charpin2020reprNABU2018-11};',
      '@bib{Charpin2020reprNABU2018-12};',
      '@bib{Charpin2020reprNABU2018-74};',
      '@bib{Charpin2020reprNABU2019-19};',
      '@bib{Charpin2020reprNABU2019-20};',
      '@bib{Charpin2020reprNABU2019-45};',
      '@bib{Charpin2020reprNABU2019-98};',
      '@bib{Charpin2020reprNABU2020-6};',
      '@bib{Charpin2020reprNABU2020-55};',
      '@bib{Charpin2020reprNABU2020-56};',
      '@bib{Charpin2020reprNABU2020-57};',
      '@bib{Charpin2020reprNABU2020-58};',
      '@bib{Charpin2020reprNABU2020-59};',
      '@bib{Charpin2020reprNABU2020-60};',
      '@bib{Charpin2020reprNABU2020-90};',
      '@bib{charpin2025ur};',
      '@bib{chen2020study};',
      '@bib{PBS_8_1};',
      '@bib{PBS_11_2}; ',
      '@bib{RN2137ax};',
      '@bib{PBS_11_3};',
      '@bib{PBS_8_2};',
      '@bib{Cifola1990Kudurru};',
      '@bib{RN14b};',
      '@bib{RN1450};',
      '@bib{RN861}; ',
      '@bib{civil1972supplement};',
      '@bib{RN1583};',
      '@bib{Civil1980Texts};',
      '@bib{Civil1984Notes};',
      '@bib{Civil1988Tablillas};',
      '@bib{LS321};',
      '@bib{RN2023abc};',
      '@bib{civil2005latebabylonian};',
      '@bib{civil2005syllabaries}; ',
      '@bib{civil2005texts};',
      '@bib{RN2023abcxxx};',
      '@bib{BE_A_10};',
      '@bib{BE_A_14};',
      '@bib{BE_A_15}; ',
      '@bib{BE_A_8_1};',
      '@bib{PBS_2_1};',
      '@bib{PBS_2_2};',
      '@bib{YOS_1};',
      '@bib{YOS_3}; ',
      '@bib{Clayden2017Dūr-Kurigalzu};',
      '@bib{cohen_sumerian_1981};',
      '@bib{RN230};',
      '@bib{MVS_17};',
      '@bib{RN311a};',
      '@bib{RN791}; ',
      '@bib{RN1557};',
      '@bib{RN1557ax};',
      '@bib{RN2740};',
      '@bib{RN2740a};',
      '@bib{Crisostomo2023Curricular}',
    ],
  },
]
